import { useQuery } from '@tanstack/react-query'
import services from './auth-services'

export const useSend2FACode = (enabled: boolean) => {
  return useQuery({
    queryKey: ['send-2fa'],
    queryFn: async () => {
      return await services.sendTwoFactorAuthCode()
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  })
}

export const useValidate2FACode = (code: string) => {
  return useQuery({
    queryKey: ['validate-2fa'],
    queryFn: async () => {
      return await services.validateTwoFactorAuthCode(code)
    },
    refetchOnWindowFocus: false,
    retry: false,
    enabled: false,
  })
}
